/** Rendered component-gallery cell for the governed page recipe (#2033). */
import { useState } from 'react'
import { DashboardWidget, PageComposition } from '@solum/ui'
import type { DescribedPage } from '@solum/experience'

const PAGE: DescribedPage = {
  resolved: true, state: 'ready', host: 'console', pageKey: 'console.gallery', reason: null,
  provenance: { scope: 'system', persona: null, solutionKey: null, version: 1 },
  document: {
    schemaVersion: 1, id: 'console.gallery', revision: 1, surface: 'page',
    sections: [{
      id: 'overview', label: 'Overview', description: 'Portable blocks in the shared section hierarchy.', columns: 4,
      items: [
        { id: 'available', kind: 'widget', dashboard: 'gallery', item: 'available', span: { desktop: 2, tablet: 2, phone: 1 }, hidden: false },
        { id: 'restricted', kind: 'widget', dashboard: 'gallery', item: 'restricted', span: { desktop: 2, tablet: 2, phone: 1 }, hidden: false },
      ],
    }], unplaced: [], dependencies: [],
  },
  blocks: [
    {
      id: 'available', section: 'overview', dashboard: 'gallery', item: 'available',
      span: { desktop: 2, tablet: 2, phone: 1 }, state: 'ready', reason: null,
      dashboardDescription: { id: 'gallery', logicalKey: 'gallery', name: 'Gallery', revision: 1 },
      provenance: { scope: 'system', pinned: false, overridden: false },
      descriptor: {
        itemKey: 'available', kind: 'kpi', slot: 1, sizeHint: 'small', hidden: false,
        collapsed: false, title: 'Open work', description: 'A governed value with a host-owned act.',
        definition: {}, definitionVersion: 1, source: {}, state: 'ready', filterFields: [],
      },
    },
    {
      id: 'restricted', section: 'overview', dashboard: 'gallery', item: 'restricted',
      span: { desktop: 2, tablet: 2, phone: 1 }, state: 'refused',
      reason: 'This component is outside your current reach.', dashboardDescription: null,
      provenance: null, descriptor: null,
    },
  ],
}

export function PageCompositionGallery() {
  const [acted, setActed] = useState(false)
  return <PageComposition page={PAGE} title="Governed page composition" eyebrow="@solum/ui"
    summary="One PageShell, shared sections, portable dashboard blocks and explicit refusal."
    status={<span role="status">{acted ? 'Action received' : 'Ready'}</span>}
    renderBlock={(block) => <DashboardWidget item={block.descriptor!} value="12"
      action={{ label: 'Review work', onInvoke: () => setActed(true) }} />}
    testId="page-composition-gallery" />
}
